import { GameVars } from "./../../GameVars";
import { GameManager } from "../../GameManager";
import { GameConstants } from "../../GameConstants";

export class LevelButton extends Phaser.GameObjects.Container {

    private level: number;

    constructor(scene: Phaser.Scene, level: number) {

        super(scene);

        this.level = level;

        const btn = new Phaser.GameObjects.Image(this.scene, 0, 0, "texture_atlas_1", "btn_" + GameVars.difficulty);
        btn.setOrigin(.5);
        btn.setInteractive();
        btn.on("pointerdown", this.onClick, this);
        this.add(btn);

        let levelMax: number;
        let colourText: string;

        switch (GameVars.difficulty) {

            case GameConstants.DIFFICULTY_EASY:
                levelMax = GameVars.gameData.achievedEasyLevel;
                colourText = "#A89B03";
                break;
            case GameConstants.DIFFICULTY_NORMAL:
                levelMax = GameVars.gameData.achievedMediumLevel;
                colourText = "#C46200";
                break;
            case GameConstants.DIFFICULTY_HERO:
                levelMax = GameVars.gameData.achievedDifficultLevel;
                colourText = "#C23627";
                break;
            default:
        }

        const levelLabel = new Phaser.GameObjects.Text(this.scene, 0, 0, this.level.toString(), {fontFamily: "Bubblegum", fontSize: "42px", color: colourText});
        levelLabel.setOrigin(.5);
        this.add(levelLabel);

        const done = new Phaser.GameObjects.Image(this.scene, 35, 35, "texture_atlas_1", "done_symbol");
        done.visible = false;
        this.add(done);

        const lock = new Phaser.GameObjects.Image(this.scene, 35, 35, "texture_atlas_1", "lock_symbol");
        lock.visible = false;
        this.add(lock);

        if (this.level > levelMax + 1 && !GameConstants.DEVELOPMENT) {
            btn.input.enabled = false;
            btn.setFrame("btns_lvls_block");
            levelLabel.setColor("#606060");
            lock.visible = true;
        } else if (this.level <= levelMax) {
            btn.on("pointerover", function (): void {
                btn.setTexture("texture_atlas_1", "btn_" + GameVars.difficulty + "_hover");
            }, this);
            btn.on("pointerout", function (): void {
                btn.setTexture("texture_atlas_1", "btn_" + GameVars.difficulty);
            }, this);
            done.visible = true;
        } else {
            btn.on("pointerover", function (): void {
                btn.setTexture("texture_atlas_1", "btn_" + GameVars.difficulty + "_hover");
            }, this);
            btn.on("pointerout", function (): void {
                btn.setTexture("texture_atlas_1", "btn_" + GameVars.difficulty);
            }, this);
        }
    }

    private onClick(): void {

        if (typeof gdsdk !== "undefined" && gdsdk.showAd !== "undefined") {
            gdsdk.showAd();
            GameVars.typeAd = "BoardScene";
            GameVars.levelAd = this.level;
        } else {
            this.scene.cameras.main.fadeOut(300, 255, 255, 255);

            this.scene.cameras.main.once("camerafadeoutcomplete", function (): void {
                GameManager.enterBoardScene(this.level);
            }, this);
        }
    }
}

